import { memo } from 'react';

import styles from './channelDashboardMetrics.module.scss';
import { ChannelDashboardAgentPresenceMetric } from './components/agentPresence/channelAgentPresenceMetric';
import { ChannelDashboardAssignmentTimeMetric } from './components/assignmentTime/channelAssignmentTimeMetric';
import { ChannelDashboardDailyConversationsMetric } from './components/dailyConversations/channelDailyConversationsMetric';
import { ChannelDashboardPendingConversationsMetric } from './components/pendingConversations/channelPendingConversationsMetric';
import { ChannelDashboardQueuedTimeMetric } from './components/queuedTime/channelQueuedTimeMetric';
import { ChannelDashboardResponseTimeMetric } from './components/responseTime/channelResponseTimeMetric';

export const ChannelDashboardMetrics = memo(
  function ChannelDashboardMetrics(): JSX.Element {
    return (
      <div className={styles.metrics}>
        <ChannelDashboardAgentPresenceMetric />
        <ChannelDashboardPendingConversationsMetric />
        <ChannelDashboardQueuedTimeMetric />
        <ChannelDashboardDailyConversationsMetric />
        <ChannelDashboardResponseTimeMetric />
        <ChannelDashboardAssignmentTimeMetric />
      </div>
    );
  },
);
